import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  ReconcileMatch,
  type ReconcileMatchConstructor,
} from './ReconcileMatch'
import { CreditCardItemConstructorFactory } from '../CreditCardItem'
import { ReconcileMatchStatuses } from '../enums/ReconcileMatchStatusEnum'
import { StatementItemConstructorFactory } from '../StatementItem'

export const ReconcileMatchConstructorFactory =
  Factory.Sync.makeFactory<ReconcileMatchConstructor>({
    id: Factory.each(() => faker.random.number()),
    status: ReconcileMatchStatuses.CONFIRMED,
    amount: Factory.each(() => faker.finance.amount()),
    creditcardItems: Factory.each(() => [
      CreditCardItemConstructorFactory.build(),
    ]),
    statementItems: Factory.each(() => [
      StatementItemConstructorFactory.build(),
    ]),
  })

export const ReconcileMatchFactory = EntityFactory(
  ReconcileMatch,
  ReconcileMatchConstructorFactory
)
